// extracted by mini-css-extract-plugin
module.exports = {"container":"_3k-EMva9K1NWZBGoF5GBPw","title":"_3U2R6wta5u1a-T9nw6qPct"};